import React from 'react'
import "boxicons"

function Intrests({intrest="Learning", emojiName="book", emojiColor="red"}) {
    return (
       <div className="icon-box">
       <box-icon name={emojiName} color={emojiColor}></box-icon>
              <i className="ri-store-line" style={{ color: "#ffbb2c" }}></i>
              <h3>{intrest}</h3>
            </div>
    )
}

export default Intrests
